import {Stack, Text} from '@mantine/core';
import React from 'react';

import {ScratchPlateContent} from './ScratchPlateTypes';

/**
 * Renders a summary of a scratch plate attached to a pipeline step: its name and
 * grid dimensions. Full plate-map rendering lives in the notebook viewer; pipelines
 * surface a lightweight summary for now.
 */
export default function ScratchPlatePaneContent({
  scratchPlate,
}: {
  scratchPlate: ScratchPlateContent;
}): JSX.Element {
  return (
    <Stack spacing="xs">
      <Text fw={600}>{scratchPlate.name}</Text>
      <Text c="dimmed">
        {scratchPlate.height} × {scratchPlate.width} plate
      </Text>
    </Stack>
  );
}
